import api from './api';

export const formationDraftService = {
  async claim(token) {
    const response = await api.post('/api/formation-drafts/claim', { token });
    return response.data;
  },

  async get(draftId) {
    const response = await api.get(`/api/formation-drafts/${draftId}`);
    return response.data;
  },

  async checkout(draftId, planCode, paymentMethodType = 'card') {
    const response = await api.post('/api/formation-drafts/checkout', {
      draftId,
      planCode,
      paymentMethodType,
      termsAccepted: true,
    });
    return response.data;
  },

  async confirmPayment(paymentIntentId, registrationId) {
    const response = await api.post('/api/confirm-payment', {
      paymentIntentId,
      registrationId,
    });
    return response.data;
  },
};

export default formationDraftService;
